module.exports = __webpack_public_path__ + "img/share_logo_icon.b3121ade.png";